<div #fsComponent class="component-width">
    <div #fsWrapper>
        <span #fsSpan>{{text}}</span>
    </div>
</div>
